import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import Switch from "../../components/Switch";
import useApiUrls from "../../useApiUrls";
import Pagination from "../components/Pagination";

const CatelogList = () => {
  const [data, setData] = useState([]);
  const [CatelogId, setCatelogId] = useState([]);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // Track message type for styling
  const [publishInfo, setPublishInfo] = useState({});
  const [dataLimit, setDataLimit] = useState(100);
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [totalItems, setTotalItems] = useState(0);

  // Copy dialog states
  const [showCopyDialog, setShowCopyDialog] = useState(false);
  const [subusers, setSubusers] = useState([]);
  const [loadingSubusers, setLoadingSubusers] = useState(false);
  const [selectedSubuser, setSelectedSubuser] = useState("");
  const [selectedCatalogForCopy, setSelectedCatalogForCopy] = useState(null);

  const { getUrlByOperation } = useApiUrls();
  const navigate = useNavigate();
  // const localStorageData = JSON.parse(localStorage.getItem("user"));
  // const token = localStorageData?.token;
  // const userid = localStorageData?.userid;
  const token = getCookie("token");
    const userid = getCookie("userid");


  // Fetch catalog and Catelog data
  useEffect(() => {
    const fetchCatalogAndCatelogData = async () => {
      try {
        const requestBody = {
          id: 0,
          applycreateddate: false,
          applymodifieddate: false,
          fromcreateddate: 0,
          endcreateddate: 0,
          frommodifieddate: 0,
          endmodifieddate: 0,
          active: "",
          catalogname: "",
          ispageload: false,
          pagesize: dataLimit,
          currentpageno: count,
          withoutpagination: false,
          pagedirection: "first",
        };
        
        const CatalogSearch = getUrlByOperation("CatalogSearch");
        const CatelogGetDistinct = getUrlByOperation("CatelogGetDistinct");

        // Fetch catalog data
        const catalogResponse = await axios.post('https://api.dqr-display-tms.bonrix.in/api/CatalogOperation/Search', requestBody, {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        });
        if (catalogResponse.data && Array.isArray(catalogResponse.data.data)) {
          const rows = catalogResponse.data.data;
          setData(rows);
          setHasMore(rows.length === Number(dataLimit));
          const approximateTotal = (count * Number(dataLimit)) + rows.length + (rows.length === Number(dataLimit) ? Number(dataLimit) : 0);
          setTotalItems(approximateTotal);
        } else {
          setData([]);
          setHasMore(false);
          setTotalItems(0);
        }

        // Fetch Catelog data
        const CatelogResponse = await axios.get(`${CatelogGetDistinct}/Catelogname`, {
          headers: {
            accept: "text/plain",
            "X-Authorization": token,
            UserId: userid,
          },
        });
        if (CatelogResponse.data && Array.isArray(CatelogResponse.data.data)) {
          setCatelogId(CatelogResponse.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCatalogAndCatelogData();
  }, [getUrlByOperation, token, userid, dataLimit, count]);

  const handlePageChange = (page) => {
    setCount(page - 1);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setDataLimit(newItemsPerPage);
    setCount(0);
  };

  const totalPages = hasMore ? count + 2 : count + 1;

  const handleAddPop = () => {
    navigate("/addcatelog");
  };

  // Function to fetch subusers
  const fetchSubusers = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    setLoadingSubusers(true);
    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/SubUserOperation/Search',
        {
          "id": 0,
          "applycreateddate": false,
          "applymodifieddate": false,
          "fromcreateddate": 0,
          "endcreateddate": 0,
          "frommodifieddate": 0,
          "endmodifieddate": 0,
          "active": "",
          "catalogname": "",
          "ispageload": false,
          "pagesize": dataLimit,
          "currentpageno": 0,
          "withoutpagination": false,
          "pagedirection": "first"
        },
        {
          headers: {
            'X-Authorization': token,
            'UserId': userid,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      if (response.data && response.data.isresponse && Array.isArray(response.data.data)) {
        setSubusers(response.data.data);
      } else {
        setSubusers([]);
      }
    } catch (error) {
      console.error("Error fetching subusers:", error);
      setSubusers([]);
    } finally {
      setLoadingSubusers(false);
    }
  };

  // Function to open copy dialog
  const handleOpenCopyDialog = (item) => {
    setSelectedCatalogForCopy(item);
    setSelectedSubuser("");
    setShowCopyDialog(true);
    fetchSubusers();
  };

  // Function to close copy dialog
  const handleCloseCopyDialog = () => {
    setShowCopyDialog(false);
    setSelectedCatalogForCopy(null);
    setSelectedSubuser("");
    setSubusers([]);
  };

  // Function to handle copy action
  const handleCopyAction = async () => {
    if (!selectedSubuser) {
      setMessage("Please select a subuser first");
      return;
    }
    
    if (!selectedCatalogForCopy) {
      setMessage("No Catalogue selected");
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      setMessage("Authentication required");
      return;
    }

    try {
      console.log("Making copy API call with selected subuser:", selectedSubuser);
      console.log("Making copy API call with Catalogue:", selectedCatalogForCopy);
      
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/CatalogOperation/Copy',
        {
          "subuserid": selectedSubuser, // Use selected subuser ID instead of hardcoded 10002
          "copyid": selectedCatalogForCopy.id, // Use selected catalog ID
          "name": selectedCatalogForCopy.catalogname // Use selected catalog name instead of hardcoded "Vmart"
        },
        {
          headers: {
            'accept': 'text/plain',
            'UserId': userid,
            'X-Authorization': token,
            'Content-Type': 'application/json-patch+json'
          }
        }
      );

      console.log("Copy API response:", response.data);

      // Check different possible response structures
      if (response.data) {
        if (response.data.isresponse) {
          setMessage("Catalogue copied successfully!");
          setMessageType("success");
          handleCloseCopyDialog(); // Close dialog after successful copy
        } else if (response.data.responsestatus === "SUCCESS") {
          setMessage("Catalogue copied successfully!");
          setMessageType("success");
          handleCloseCopyDialog(); // Close dialog after successful copy
        } else {
          console.error("API response indicates failure:", response.data);
          const errorMessage = response.data.errormsg || response.data.message || 'Unknown error';
          setMessage(`Failed to copy Catalogue: ${errorMessage}`);
          setMessageType("error");
        }
      } else {
        console.error("No response data received");
        setMessage("Failed to copy Catalogue: No response from server");
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error copying Catalogue:", error);
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error status:", error.response.status);
        setMessage(`Failed to copy Catalogue: ${error.response.data?.message || error.message}`);
      } else {
        setMessage(`Failed to copy Catalogue: ${error.message}`);
      }
    }
  };

  const handleUpdatePop = (id) => {
    navigate(`/updatecatelog/${id}`);
  };

  const handleShowImagePop = (id) => {
    navigate(`/showcatelog/${id}`);
  };

  const handlePreview = (id) => {
    const previewUrl = `/catelogpreview/${id}`;
    window.open(previewUrl, "_blank");
  };

  const encodeId = (id) => {
    const strId = id.toString();
    const base64Id = btoa(strId);
    return base64Id.substring(0, 10).padEnd(8, "0"); // Limit to 8-10 characters
  };

  const handlePublish = async (item) => {
    // Use publishid if available, otherwise fall back to encoded id
    const publishId = item.publishid && item.publishid.trim() !== '' 
      ? item.publishid 
      : encodeId(item.id);
      const type = "admin";
    
    const publishUrl = `${window.location.origin}/SMD/catelog/${type}/${publishId}`;
    setPublishInfo({ id: item.id, encodedUrl: publishUrl, encodedId: publishId });

    try {
      await navigator.clipboard.writeText(publishUrl);
      setMessage("URL copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy URL:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Catalogue?")) {
      const requestBody = { id };

      try {
        const CatalogDelete = getUrlByOperation("CatalogDelete");
        await axios.post(CatalogDelete, requestBody, {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        });
        setMessage("Data deleted successfully!");
        setData(data.filter((item) => item.id !== id));
      } catch (error) {
        console.error("Error deleting item:", error);
        setMessage("Failed to delete data");
      }
    }
  };

  const handleToggle = async (item) => {
    const CatalogActive = getUrlByOperation("CatalogActive");
    const CatalogDeactive = getUrlByOperation("CatalogDeactive");
    const apiUrl = item.active
      ? CatalogDeactive
      : CatalogActive;

    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
      if (error.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">Catalogue</h1>
                <button type="button" className="btn btn-success" onClick={handleAddPop}>
                  Add Catalogue
                </button>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <hr />
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body table-responsive p-0">
                      <table className="table table-hover table-striped">
   <thead className="thead-light" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
    <tr>
      <th style={{width: '5%'}} className="text-center">Id</th>
      <th style={{width: '15%'}}>Name</th>
      <th style={{width: '15%'}}>Catalogue Description</th>
      <th style={{width: '12%'}} className="text-center">Show Images</th>
      <th style={{width: '25%'}} className="text-center">Action</th>
      <th style={{width: '10%'}} className="text-center">Active</th>
      <th style={{width: '18%'}} className="text-center">Publish</th>
    </tr>
  </thead>
  <tbody>
    {data.map((item) => (
      <tr key={item.id}>
        <td className="text-center">{item.id}</td>
        <td>
          <strong>{item.catalogname}</strong>
        </td>
        <td>{item.remark || "-"}</td>
        <td className="text-center">
          <button 
            className="btn btn-sm btn-info"
            onClick={() => handleShowImagePop(item.id)}
          >
            <i className="fas fa-images mr-1"></i> 
            {/* Show Images */}
          </button>
        </td>
        <td className="text-center">
          <div className="btn-group">
            <button 
              className="btn btn-sm btn-success mr-1" 
              onClick={() => handleUpdatePop(item.id)}
            >
              <i className="fas fa-edit mr-1"></i>
               {/* Update */}
            </button>
            <button 
              className="btn btn-sm btn-danger mr-1" 
              onClick={() => handleDelete(item.id)}
            >
              <i className="fas fa-trash mr-1"></i>
               {/* Delete */}
            </button>
            {/* <button 
              className="btn btn-sm btn-primary mr-1" 
              onClick={() => handlePreview(item.id)}
            >
              <i className="fas fa-eye mr-1"></i>
               
            </button> */}
            <button 
              className="btn btn-sm btn-success mr-1" 
              onClick={() => handleOpenCopyDialog(item)}
            >
              <i className="fas fa-copy mr-1"></i>
               {/* Copy */}
            </button>
          </div>
        </td>
        <td className="text-center">
          <Switch 
            isOn={item.active} 
            handleToggle={() => handleToggle(item)} 
            id={item.id} 
          />
        </td>
        <td className="text-center">
          {publishInfo.id === item.id ? (
            <div className="d-flex flex-column align-items-center">
              <span className="badge badge-info mb-2">{publishInfo.encodedId}</span>
              <button
                className="btn btn-sm btn-success"
                onClick={() => {
                  navigator.clipboard.writeText(publishInfo.encodedUrl);
                  setMessage("URL copied to clipboard!");
                }}
                title="Copy"
              >
                <i className="fas fa-copy mr-1"></i> Copy URL
              </button>
            </div>
          ) : (
            <button 
              className="btn btn-sm btn-success"
              onClick={() => handlePublish(item)}
            >
              <i className="fas fa-globe mr-1"></i> Publish
            </button>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</table>
                      <Pagination
                        currentPage={count + 1}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                        itemsPerPage={dataLimit}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        totalItems={totalItems}
                        showPageNumbers={false}
                        showItemsPerPageSelector={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <div style={{ position: "fixed", top: "20px", right: "10px", width: "25%", zIndex: "9999" }}>
          <div
            className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"} d-flex align-items-center`}
            role="alert"
            style={{ marginBottom: "10px" }}
          >
            <div>{message}</div>
          </div>
        </div>
      )}
      
      {/* Copy Dialog */}
      {showCopyDialog && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "block"
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document" style={{ width: "100%", maxWidth: "400px" }}>
            <div className="modal-content" style={{ borderRadius: "15px", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}>
              <div className="modal-header" style={{ borderBottom: "1px solid #f0f0f0", padding: "1.5rem" }}>
                <h5 className="modal-title" style={{ fontWeight: "700", color: "#333", fontSize: "1.25rem" }}>
                  <i className="fas fa-copy mr-2 text-success"></i>
                  Copy Catalogue to Subuser
                </h5>
                <button type="button" className="close" onClick={handleCloseCopyDialog} style={{ outline: "none" }}>
                  <span aria-hidden="true" style={{ fontSize: "1.5rem" }}>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ padding: "1.5rem" }}>
                {message && (
                  <div className="alert alert-info" role="alert">
                    {message}
                  </div>
                )}

                <div className="form-group">
                  <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>
                    <i className="fas fa-user mr-2 text-muted"></i>Select Subuser
                  </label>
                  <select
                    className="form-control custom-select"
                    value={selectedSubuser}
                    onChange={(e) => setSelectedSubuser(e.target.value)}
                    style={{ borderRadius: "8px", padding: "0.6rem 1rem", height: "auto" }}
                    disabled={loadingSubusers}
                  >
                    <option value="">{loadingSubusers ? "Loading subusers..." : "Select subuser..."}</option>
                    {subusers.map((subuser, index) => (
                      <option key={index} value={subuser.id}>
                        {subuser.username}
                      </option>
                    ))}
                  </select>
                </div>

                {selectedCatalogForCopy && (
                  <div className="mt-3 p-3 bg-light rounded" style={{ fontSize: "0.85rem" }}>
                    <strong>Selected Catalogue:</strong> {selectedCatalogForCopy.catalogname}
                  </div>
                )}
              </div>
              <div className="modal-footer" style={{ borderTop: "1px solid #f0f0f0", padding: "1.25rem 1.5rem", justifyContent: "space-between" }}>
                <button
                  type="button"
                  className="btn"
                  onClick={handleCloseCopyDialog}
                  style={{ fontWeight: "600", color: "#6c757d", padding: "0.6rem 1.5rem" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleCopyAction}
                  disabled={loadingSubusers || !selectedSubuser}
                  style={{
                    fontWeight: "700",
                    padding: "0.6rem 2rem",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(40,167,69,0.3)",
                    transition: "transform 0.2s"
                  }}
                >
                  <i className="fas fa-copy mr-2"></i>
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CatelogList;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
